import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import EditSpeakerProfileModal from './EditSpeakerProfileModal';
import { ActionButton } from 'yoda-ui/components/BiogenLincDS/Buttons';
import { ButtonVariant } from 'yoda-ui/components/BiogenLincDS/Buttons/Buttons.types';
import Box from 'yoda-ui/components/Box';
import { Icons } from 'yoda-ui/components/Icons/Icon';

const EditSpeakerProfile: FC = () => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <Box>
      <ActionButton
        label={ t('events_modal_speakerprofile_open_btn_label') }
        icon={ Icons.add }
        onClick={ () => { setOpen(true); } }
        variant={ ButtonVariant.primary }
      />
      <EditSpeakerProfileModal open={ open } setOpen={ setOpen } />
    </Box>
  );
};

export default EditSpeakerProfile;
